import { TyreChange } from './tyre-change'
import { APIResponse } from '../../helpers'

export type TyreChangeForVehicleResponse = APIResponse<TyreChange>

export interface GetLastTyreChangeParams {
  invoiced?: boolean
}

export const getLastTyreChange = (vehicleUUID: string, params?: GetLastTyreChangeParams) => ({
  method: 'GET',
  url: `/modules/tyre-changes/for-vehicle/${vehicleUUID}`,
  params
})
